import CryptoJS from "crypto-js";
import { AES_CONFIG } from "../config/aes-config";

/**
 * Encrypts plain text using AES-256-CBC encryption
 * Matches the backend encryption logic
 * @param plainText - The text to encrypt
 * @returns Encrypted text in base64 format
 */
export const encryptAES256CBC = (plainText: string): string => {
  try {
    // Use configuration values
    const AES_IV = AES_CONFIG.IV;
    const AES_SECRET = CryptoJS.MD5(AES_IV).toString(); // MD5 hash of IV as secret

    // Convert secret to WordArray (32 bytes for AES-256)
    const key = CryptoJS.enc.Utf8.parse(AES_SECRET);
    const iv = CryptoJS.enc.Utf8.parse(AES_IV);

    // Encrypt using AES-256-CBC
    const encrypted = CryptoJS.AES.encrypt(plainText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Return base64 encoded result
    return encrypted.toString();
  } catch (error) {
    console.error("Encryption error:", error);
    throw new Error("Invalid tokenLogin encryption");
  }
};

/**
 * Decrypts AES-256-CBC encrypted text (for testing purposes)
 * @param encryptedText - The encrypted text in base64 format
 * @returns Decrypted plain text
 */
export const decryptAES256CBC = (encryptedText: string): string => {
  try {
    const AES_IV = AES_CONFIG.IV;
    const AES_SECRET = CryptoJS.MD5(AES_IV).toString();

    const key = CryptoJS.enc.Utf8.parse(AES_SECRET);
    const iv = CryptoJS.enc.Utf8.parse(AES_IV);

    const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption error:", error);
    throw new Error("Invalid tokenLogin decryption");
  }
};
